<template>
  <v-row>
    <v-col class="calendar">
      <v-menu
        ref="menu"
        v-model="menu1"
        :close-on-content-click="false"
        :return-value.sync="s_Date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="startDate" :value="s_Date" readonly v-bind="attrs" v-on="on"></v-text-field>
        </template>
        <v-date-picker locale="ko-KR" v-model="startDate" @change="emitSetDate" no-title scrollable> </v-date-picker>
      </v-menu>
    </v-col>
    <v-col class="calendar">
      <v-menu
        ref="menu"
        v-model="menu2"
        :close-on-content-click="false"
        :return-value.sync="e_Date"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field :value="e_Date" v-model="endDate" readonly v-bind="attrs" v-on="on"></v-text-field>
        </template>
        <v-date-picker locale="ko-KR" v-model="endDate" :min="startDate" @change="emitSetDate" no-title scrollable>
        </v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      s_Date: '',
      e_Date: '',
      menu1: false,
      menu2: false,
    };
  },

  mounted() {
    if (this.propsDate != null) {
      this.startDate = this.propsDate.startDate;
      this.endDate = this.propsDate.endDate;
    }
  },

  watch: {
    propsDate() {
      this.startDate = this.propsDate.startDate;
      this.endDate = this.propsDate.endDate;
    },
  },

  methods: {
    emitSetDate() {
      this.propsDate.startDate = this.startDate;
      this.propsDate.endDate = this.endDate;
      this.$emit('emitSetDate', this.startDate, this.endDate);
    },
  },
  props: ['propsDate'],
};
</script>
